import React, { useState, useEffect } from 'react'
import _map from 'lodash/map'
import Select from 'react-select'
import Button from './Button'
import FilterItemsField from './FilterItemsField'

const FiltersNew = ({ filters, children, className, onFiltersChange, value }) => {
  const [currentFilter, setCurrentFilter] = useState([])
  const [selected, setSelected] = useState(() => {
    const initialSelected = {}
    _map(filters, filter => {
      initialSelected[filter.type] = {
        value: null,
        label: filter.label,
        isNotChecked: false,
      }
    })
    return initialSelected
  })

  useEffect(() => {
    if (value !== currentFilter) {
      setCurrentFilter(value)
    }
  }, [value, currentFilter])

  const handleChange = (type, val) => {
    setSelected(prevSelected => ({
      ...prevSelected,
      [type]: {
        ...prevSelected[type],
        value: (val && val.value) || null,
      },
    }))
  }

  const onNotChecked = (type, checked) => {
    setSelected(prevSelected => ({
      ...prevSelected,
      [type]: {
        ...prevSelected[type],
        isNotChecked: checked,
      },
    }))
  }

  const onOperationClick = (type, isAnd) => {
    const newFilter = [
      ...currentFilter,
      {
        isAnd,
        type,
        label: selected[type].label,
        value: selected[type].value,
        isNot: selected[type].isNotChecked,
      },
    ]
    setCurrentFilter(newFilter)
    onFiltersChange(newFilter)
  }

  const onTagsChange = (tags, _, changedIndexes) => {
    if (currentFilter.length > tags.length) {
      const newFilter = [...currentFilter]
      newFilter.splice(changedIndexes[0], 1)
      onFiltersChange(newFilter)
    }
  }

  const isInitial = currentFilter.length === 0
  const tags = _map(currentFilter, (filter) => {
    const item = {
      label: filter.label,
      value: filter.label === 'Status' ? filter.value.charAt(0).toUpperCase() + filter.value.slice(1) : filter.value,
      isNot: filter.isNot,
      isAnd: filter.isAnd,
    }

    return item
  })

  return (
    <div className={`common-filters ${className || ''}`}>
      {tags.length > 0 && (
        <div className="f-output">
          <FilterItemsField
            value={tags}
            onChange={(tags, changed, changedIndexes) => onTagsChange(tags, changed, changedIndexes)}
            controlOutside
            placeholder={' '}
            disabled={!tags?.length}
          />
        </div>
      )}
      <div className="f-body flex-align">
        {_map(filters, (filter, index) => (
          <div key={index} className="f-item">
            <div className="f-header">
              <div className="f-label">{filter.label}</div>
              <div className="f-checkbox">
              <label className="checkbox-description" htmlFor={`chkNegative_${index}`}>Not</label>

                <div className="checkbox-group-square">
                  <div className="checkbox-square small">
                    <input
                      id={`chkNegative_${index}`}
                      type="checkbox"
                      disabled={!selected[filter.type].value}
                      checked={selected[filter.type].isNotChecked}
                      onChange={evt => onNotChecked(filter.type, evt.target.checked)}
                    />
                    <label htmlFor={`chkNegative_${index}`} />
                  </div>
                </div>
              </div>
            </div>
            <div className="f-dropdown">
              <Select
                onChange={evt => handleChange(filter.type, evt)}
                options={filter.options}
                value={selected[filter.type].value}
              />
            </div>
            <div className="f-buttons">
              {isInitial && (
                <Button
                  className="btn btn-primary"
                  type="button"
                  disabled={!selected[filter.type].value}
                  onClick={() => onOperationClick(filter.type, true)}
                >
                  Add
                </Button>
              )}
              {!isInitial && (
                <Button
                  className="btn btn-primary"
                  type="button"
                  disabled={!selected[filter.type].value}
                  onClick={() => onOperationClick(filter.type, true)}
                >
                  And
                </Button>
              )}
              {!isInitial && (
                <Button
                  className="btn btn-default"
                  type="button"
                  disabled={!selected[filter.type].value}
                  onClick={() => onOperationClick(filter.type, false)}
                >
                  Or
                </Button>
              )}
            </div>
          </div>
          ))}
      </div>
      {children}
    </div>
  )
}

export default FiltersNew
